import React, { useEffect } from 'react';
import { widgetize } from 'common/widgetize';
import { WidgetProps } from './models/RequestAccessWidgetProps';
import { RequestAccessWidget } from './components/RequestAccessWidget';
import { RequestAccessGlobalWorkflowProvider } from './contexts/RequestAccessGlobalWorkflowContext';
import { initUserInfo } from './services/SgConnectService';
import { WithSGBootstrap } from 'common/components/WithSGBootstrap';

const USE_SHADOW_DOM = true;

const SgMarketsRequestAccess: React.FC<WidgetProps> = (
  props: WidgetProps,
) => {
  useEffect(() => {
    initUserInfo();
  }, []);

  const sanitizeProps: WidgetProps = {
    ...props,
    classbtn: props.classbtn || 'btn btn-lg btn-discreet-socgen',
    colorSubmitBtn: `btn-${props.colorSubmitBtn || 'socgen'}`,
  };

  return <WithSGBootstrap version={sanitizeProps.sgBootstrap}>
    <RequestAccessGlobalWorkflowProvider widgetProps={sanitizeProps}>
      <RequestAccessWidget />
    </RequestAccessGlobalWorkflowProvider>
  </WithSGBootstrap>;
};

export const RequestAccessWebcomponent = widgetize(
  SgMarketsRequestAccess,
  'sgmarkets-request-access',
  {
    attributes: [
      { name: 'ressource-id', type: 'string' },
      { name: 'classbtn', type: 'string' },
      { name: 'icid', type: 'string' },
      { name: 'color-submit-btn', type: 'string' },
      { name: 'url', type: 'string' },
      { name: 'use-icon', type: 'boolean' },
      { name: 'pops-identifier', type: 'string' },
      { name: 'source-url', type: 'string' },
      { name: 'source-context', type: 'string' },
      { name: 'site', type: 'object' },
      { name: 'sg-bootstrap', type: 'string' },
    ],
    events: [
      { name: 'request-sent', functionName: 'emitRequestSent'/*, description: '`requestSent` request task object | The request task object that was sent'*/ },
      { name: 'get-service', functionName: 'emitGetService'/*, description: '`service` object | The service object retrieved by api'*/ },
    ],
  },
  { shadow: USE_SHADOW_DOM },
);
